import axios from 'axios'
import { OrganizationFeatureFlagsResponse } from 'src/models/organizations.models'
import { getRequestConfig } from 'src/queries/requestConfig'

export const getOrganizationFeatureFlags = async (
  orgId: string,
): Promise<OrganizationFeatureFlagsResponse> =>
  axios
    .get<OrganizationFeatureFlagsResponse>(
      `organizations/${orgId}/featureflags`,
      getRequestConfig(),
    )
    .then((response) => response.data)
